import { useState, useEffect } from 'react';

/** True when the app was opened with ?payments=true (e.g. from Flutter WebView with showPayments flag). */
export function useShowPaymentsFlag(): boolean {
  const [show, setShow] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem('showPayments') === 'true',
  );
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('payments') === 'true') setShow(true);
  }, []);
  return show;
}
